// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tH3+4","dashboardWrapper":"styles_dashboardWrapper__0N+Uw"};